import { FormFieldEventType, FormFieldType, InsuranceParamGroup, InsuranceParamType, QuestionResult } from "app/utility/enums";
import { LookupExternalModel, LookupInternalModel } from "../shared/lookup.model";
import { ProductQuoteModel } from "./productQuote.model";

export class InsuranceProviderValidationModel
{
    errorMessage: string;
    selectedInsuranceProviderEnum: number;
    vehicleId: string;
    saleId: string;
    productClass: string;
    selectedProductId: string;
    containsProductQuote: boolean;

    // Sideload
    mviProductQuote: ProductQuoteModel;
    selectedInsuranceProvider: LookupInternalModel;
    availableInsuranceProviders: LookupInternalModel[];
    configFields: ConfigFieldModel[];
    additionalQuestions: DealerzoneQuestionModel[];
    insuranceParams: InsuranceParamModel[];
    manuModelVariant: InsuranceProviderManuModelVariantModel
}

export class ConfigFieldModel
{
    id: string;
    fieldType: FormFieldType;
    eventType: FormFieldEventType;
    eventMessage: string;
    isMandatory: boolean;
}

export class DealerzoneQuestionModel
{
    id: string;
    questionText: string;
    isElectricVehicleOnly: boolean;
    answer: QuestionResult;
    premiumAddOnAmountRetail: number;
    premiumAddOnAmountWholesale: FormFieldType;
}

export class InsuranceParamModel
{
    paramId: string;
    paramFieldType: FormFieldType;
    paramEventType: FormFieldEventType;
    paramLabel: string;
    paramIsMandatory: boolean;
    paramType: InsuranceParamType;
    paramGroup: InsuranceParamGroup;
    sequence: number;

    paramValue: any;
    paramObject: any;

    paramParentId: string;
    paramHasChildren: boolean;
    paramEditableWhen: string;
    paramIsEditable: boolean = true;
}

export class InsuranceProviderManuModelVariantModel
{
    saleId: string;
    vehicleId: string;
    selectedInsuranceProviderEnum: number;
    productClass: string;

    manufacturerId: string
    modelId: string;
    variantId: string;

    selectedManufacturerCaption: string;
    selectedModelCaption: string;
    selectedVariantCaption: string;

    manufacturers: LookupExternalModel[] = [];
    models: LookupExternalModel[] = [];
    variants: LookupExternalModel[] = [];
    
}